import { useLang } from '../context/LanguageContext';
import {
  BUSINESS,
  businessAddressBlock,
  businessPhoneDisplay,
  businessTelHref,
  businessWhatsAppHref,
} from '../config/business';
import './BusinessLegalStrip.css';

/** Visible legal entity + GST block for homepage, footer, and policy pages */
export default function BusinessLegalStrip({ compact = false }) {
  const { t } = useLang();

  if (compact) {
    return (
      <p className="biz-legal biz-legal--compact">
        <strong>{BUSINESS.legalName}</strong>
        <span className="biz-legal__sep"> · </span>
        {t.gstLabel}: {BUSINESS.gstin}
      </p>
    );
  }

  return (
    <div className="biz-legal">
      <p>
        <strong>{t.legalEntityLabel}:</strong> {BUSINESS.legalName}
      </p>
      <p>
        <strong>{t.tradeNameLabel}:</strong> {BUSINESS.tradeName}
      </p>
      <p>
        <strong>{t.gstLabel}:</strong> {BUSINESS.gstin}
      </p>
      <p>
        <strong>{t.businessTypeLabel}:</strong> {BUSINESS.constitution}
      </p>
      <p>
        <strong>{t.contactAddressLabel}:</strong> {businessAddressBlock()}
      </p>
      <p>
        <strong>{t.contactEmailLabel}:</strong>{' '}
        <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
      </p>
      <p>
        <strong>{t.contactPhoneLabel}:</strong>{' '}
        <a href={businessTelHref()}>{businessPhoneDisplay()}</a>
      </p>
      <p>
        <strong>{t.contactWhatsAppLabel}:</strong>{' '}
        <a href={businessWhatsAppHref()} target="_blank" rel="noreferrer">
          {businessPhoneDisplay()}
        </a>
      </p>
    </div>
  );
}
